export const VISIBLE = 'VISIBLE';
export const COLLAPSED = 'COLLAPSED';
export const LOCKED = 'LOCKED';
